module.exports = __webpack_public_path__ + "assets/img/index-partner20.7584c37d.jpg";